/**
 * A function to create the mutations to set the selected categories form the sellers
 * as a global app setting in the store and to load it from the local storage.
 * 
 * @param {Object} [storage] generated with the `createNamespacedLocalStorageFunctions`
 *  function present in the `local-storage` file in the store directory. Is an optional
 *  parameter to store the value of this mutation in the local storage with the namespace
 *  of the correspondent module of the store.
 * 
 * @returns {Object} with the mutation to set the value in the store and another mutation
 *  to load the value from the local storage.
 */
export default storage => {
  const storageKey = 'appSettingsSellersCategories'

  /**
   * AVOID USING THIS MUTATION DIRECTLY. Please use the action with the same name.
   *
   * Set the sellers categories in the app to use only items from these categories.
   *
   * @param {Object} state
   * @param {Number[]} ids
   */
  function setAppSettingsSellersCategories(state, categories) {
    state.appSettings.sellersCategories = categories
    storage.setItem(storageKey, JSON.stringify(categories))
  }


  /**
   * Load an parse the sellers categories present in the local storage and set them
   * in the app setting.
   *
   * @param {Object} state
   */
  function loadAppSettingsSellersCategoriesFromStorage(state) {
    const categories = JSON.parse(storage.getItem(storageKey))

    if (categories) {
      setAppSettingsSellersCategories(state, categories)
    }
  }


  return {
    loadAppSettingsSellersCategoriesFromStorage,
    setAppSettingsSellersCategories
  }
}
